import empty from '@/utils/vueInstance';

export default {
  data () {
    return {
      cascadeParam: {}
    };
  },
  methods: {
    /* 获取省市区 */
    regionSelect (index, scope = 'searchList', type = '1,2,3,4') {
      this.$get({
        url: '/get_area_tree',
        params: { type: type }
      }).then(({data}) => {
        let argument = arguments[0];
        if (argument && typeof argument === 'function') {
          argument(data);
        } else {
          this[scope][index].options = data;
        }
      });
    },
    /* 获取物业下拉 */
    propertySelect (index, scope = 'searchList') {
      this.$get({
        url: '/select_list/property_list',
        params: {}
      }).then(({data}) => {
        this[scope][index].options = data.property_list;
      });
    },

    communitySelectByStep (pageNum, search, scope = 'formList', index = '2', exitValue, area, istransfer = false) {
      if (exitValue && exitValue.indexOf(',') > -1) {
        return new Promise((resolve, reject) => {
          let params = {};
          let areas;
          if (area) {
            areas = area.toString();
          }
          if (pageNum == undefined) {
            params = {
              search,
              pageNum: 1,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          } else {
            params = {
              search,
              pageNum,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          }
          this._get({
            url: '/community/treeselect/page',
            params
          }).then(({data}) => {
            let newArr = data.rows;

            if (pageNum == undefined || pageNum == 1) {
              this.selectCurrentPage = 1;
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = [].concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = [].concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            } else {
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = this[scope][index].options.concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = this[scope][index].options.concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            }

            resolve({
              total: data.total,
              totalPage: data.totalPage
            });
          }, (err) => {
            console.log('Err', err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          let params = {};
          let areas;
          if (area) {
            areas = area.toString();
          }
          if (pageNum == undefined) {
            params = {
              search,
              pageNum: 1,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          } else {
            params = {
              search,
              pageNum,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          }
          this._get({
            url: '/community/treeselect/page',
            params
          }).then(({data}) => {
            let newArr = [];
            if (exitValue && params.pageNum != 1) {
              let oldArr = data.rows;
              newArr = oldArr.filter(item => item.value != exitValue);
            } else {
              newArr = data.rows;
            }

            if (pageNum == undefined || pageNum == 1) {
              this.selectCurrentPage = 1;
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = [].concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = [].concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            } else {
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = this[scope][index].options.concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = this[scope][index].options.concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            }

            resolve({
              total: data.total,
              totalPage: data.totalPage
            });
          }, (err) => {
            console.log('Err', err);
          });
        });
      }
    },
    /* 获取小区下拉 */
    communitySelect (index, scope = 'searchList', isPosition) {
      this.$get({
        url: '/select_list/gov_community_list',
        params: {
          search: '',
          is_show_position: isPosition || 0
        }
      }).then(({data}) => {
        let argument = arguments[0];
        if (argument && typeof argument === 'function') {
          argument(data.community_list);
        } else {
          this[scope][index].options = data.community_list;
        }
      });
    },
    /* 获取楼栋下拉 */
    buildSelect (index, cascadeParam = {}, scope = 'searchList') {
      this.$get({
        url: '/select_list/community_building_list',
        params: {
          community_id: cascadeParam.communityId,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data.community_building_list;
      });
    },
    /* 获取单元下拉 */
    unitSelect (index, cascadeParam = {}, scope = 'searchList') {
      this.$get({
        url: '/select_list/community_units_list',
        params: {
          community_id: cascadeParam.communityId,
          building_id: cascadeParam.buildingId,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data.community_units_list;
      });
    },
    /* 获取房间下拉 */
    roomSelect (index, cascadeParam = {}, scope = 'searchList') {
      this.$get({
        url: '/select_list/community_room_list',
        params: {
          community_id: cascadeParam.communityId,
          building_id: cascadeParam.buildingId,
          units_id: cascadeParam.unitId
        }
      }).then(({data}) => {
        this[scope][index].options = data.community_room_list;
      });
    },

    /* 获取位置下拉 */
    positionSelect (index, cascadeParam = {}, scope = 'searchList') {
      this.$get({
        url: '/select_list/position_list',
        params: {
          community_id: cascadeParam.communityId,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data.position_list;
      });
    },
    /* 获取设备下拉 */
    deviceSelect (index, cascadeParam = {}, scope = 'searchList') {
      this.$get({
        url: '/select_list/devices_list',
        params: {
          position_id: cascadeParam.position_id,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data.devices_list;
      });
    },
    /* 获取产品分类 */
    categorySelect (index = 0, scope = 'searchList', level = 4) {
      this.$get({
        url: '/category/product/get_category_list',
        params: { level: level }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    /* 小区change,联动位置列表 */
    communityChange_getPosi (index, val, scope) {
      this.cascadeParam.communityId = val;
      this.positionSelect(index, this.cascadeParam, scope);
    },
    /* 小区change,联动位置列表 */
    positionChange (index, val, scope) {
      this.cascadeParam.position_id = val;
      this.deviceSelect(index, this.cascadeParam, scope);
    },

    /* 小区change,联动楼栋列表 */
    communityChange (index, val, scope) {
      empty.$emit('resetForm', ['building_id', 'unit_id', 'room_id']);
      this.cascadeParam.communityId = val;
      this.buildSelect(index, this.cascadeParam, scope);
    },
    /* 楼栋change，联动单元列表 */
    buildingChange (index, val, scope) {
      empty.$emit('resetForm', ['unit_id', 'room_id']);
      this.cascadeParam.buildingId = val;
      this.unitSelect(index, this.cascadeParam, scope);
    },
    /* 单元change，联动房间列表 */
    unitChange (index, val, scope) {
      empty.$emit('resetForm', ['room_id']);
      this.cascadeParam.unitId = val;
      this.roomSelect(index, this.cascadeParam, scope);
    },

    /* 会员管理下拉（会员管理模块） */
    memberManageSelect (paramArr) {
      this.$get({
        url: '/select_list/member_manage_list',
        params: {}
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
        });
      });
    },
    /*  设备管理下拉（设备管理模块） */
    deviceManageSelect (paramArr, query) {
      this.$get({
        url: '/select_list/devices_manage_list',
        params: query
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
        });
      });
    },
    /*  物业管理下拉（物业管理模块） */
    propertyManageSelect (paramArr) {
      this.$get({
        url: '/select_list/property_manage_list',
        params: {}
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
        });
      });
    },
    /*  运营管理下拉（运营管理模块） */
    marketingManageSelect (param) {
      this.$get({
        url: '/select_list/operate_manage_list',
        params: {}
      }).then(({data}) => {
        if (param && typeof param === 'function') {
          param(data);
        } else {
          param.forEach((ele) => {
            this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
          });
        }
      });
    },
    /* 获取通用类别（晓纹接口） */
    typeSelect (params) {
      this.$get({
        url: '/get_typedesc',
        params: { type: params.query, format: params.format }
      }).then(({data}) => {
        if (params.handle && typeof params.handle === 'function') {
          params.handle(data);
        } else {
          this[params.scope || 'formList'][params.index].options = data;
        }
      });
    },
    /* 获取角色列表 */
    roleSelect (handle) {
      this.$get({
        url: '/get_roles_tree',
        params: {}
      }).then(({data}) => {
        if (typeof handle === 'function') {
          handle(data);
        }
      });
    }
  }
};
